// Generated by purs version 0.15.15
var buildPageCounterViewProps = function (input) {
    return {
        pageCounterRouteLabel: input.pageCounterRouteLabel,
        pdfGuidance: input.pdfGuidance,
        uploadLabel: input.uploadLabel,
        retryLabel: input.retryLabel,
        selectedFileName: input.selectedFileName
    };
};
export {
    buildPageCounterViewProps
};
//# sourceMappingURL=index.js.map
